import { Availability } from '../../../data/use-clinician'
import { getToken } from '../../auth'
import { SaveCartResponse } from '../../cart'
import { apiRequest } from '../../request'

export async function lockSlot(clinicianId: number, sessionKey: string, productId: number, selectedSlot: Availability) {
  return apiRequest<SaveCartResponse>(`/schedule/clinician/${clinicianId}/lock`, {
    body: {
      productId: productId,
      startTime: selectedSlot.startTime,
      endTime: selectedSlot.endTime,
      sessionKey,
    },
    getToken,
    method: 'POST',
  })
}

export async function unlockSlot(clinicianId: number, sessionKey?: string) {
  return apiRequest<SaveCartResponse>(`/schedule/clinician/${clinicianId}/unlock`, {
    body: {
      sessionKey,
    },
    method: 'POST',
  })
}
